import React from 'react';
import { useUser } from '../../Context/UserContext';
import { useNav } from '../../Context/NavContext';
import './LogoutButton.css';

function LogoutButton() {
  const { logout } = useUser();
  const { setActiveItem } = useNav();

  const handleLogout = () => {
    logout(); // Clear user data from context and localStorage
    setActiveItem('HOME'); // Navigate to home page
  };

  return (
    <button className="logout-btn" onClick={handleLogout}>
      Logout
    </button>
  );
}

export default LogoutButton; 